import { EntityLink } from '@/shared/ui/entity-link'

interface CallLinkProps {
  id: string
  label?: string
  className?: string
}

export function CallLink({ id, label, className }: CallLinkProps) {
  return (
    <EntityLink
      to="/calls/$callId"
      params={{ callId: id }}
      // Разбор всегда открывается с доски завершённых: живого звонка в ней нет.
      search={{ tab: 'completed' }}
      icon="phone-call"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}
